<template>
  <div v-if="!isEmptyData(item.operation.chassis_no)">
    <div
      :class="{ 'blur-xs': !item.operation.chassis_connected }"
      class="hover:blur-none"
    >
      {{ item.operation.chassis_no }}
    </div>
  </div>
</template>

<script>
export default {
  name: "order-status-yard-chassis",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
